export default "__VITE_ASSET__BpbteRjX__"